import React, { useEffect, useState } from 'react';
import { Box, styled, Badge, Typography, Button, Dialog } from '@mui/material';
// import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp';
import { useSelector } from 'react-redux';
import { getAuthSelector } from '../../utils/selectors/selectors';
import { useNavigate } from 'react-router-dom';
import { userLSAuth } from '../../app/features/env';
import ProfileMenu from './ProfileMenu';
import CalculatorApp from '../../calculator/CalculatorApp';


const HeaderWrapper = styled(Box)(
   ({ theme }) => `
      height: ${theme.header.height};
      color: ${theme.header.textColor};
      padding: ${theme.spacing(0, 6)};
      top: 0;
      left: 0;
      right: 0;
      background-color: white;
      position: fixed;
      justify-content: space-between;
      width: 100%;
      z-index: 100;
   `
);

// notification icon
// const NotificationsBadge = styled(Badge)(
//    ({ theme }) => `
//       .MuiBadge-badge {
//           background-color: ${theme.palette.error.main};
//           color: ${theme.palette.error.contrastText};
//           min-width: 18px;
//           height: 18px;
//           padding: 0;
//       }
//   `
// );


const Header = ({
   getHamState,
   isOpen,
   mobileOpen,
   getMobileHamState,
   getLogOutState,
}) => {
   const selector = useSelector(getAuthSelector);
   const navigate = useNavigate();
   const [openMenu, setOpenMenu] = useState(true);
   const [mobileOpenMenu, setMobileOpenMenu] = useState(false);
   const [isMorning, setIsMorning] = useState('');
   const [isMobile, setIsMobile] = useState(false);
   const [calculate, setCalculate] = useState(false);
   const [img, setImg] = useState('');

   useEffect(() => {
      const currentHour = new Date().getHours();
      if (currentHour >= 5 && currentHour < 12) {
         setIsMorning('Good Morning');
      } else if (currentHour >= 12 && currentHour < 16) {
         setIsMorning('Good Afternoon');
      } else if (currentHour >= 16 && currentHour < 24) {
         setIsMorning('Good Evening');
      } else {
         setIsMorning('Good Night');
      }
   }, []);

   useEffect(() => {
      setImg(userLSAuth()?.displayPicture);
   }, [
      selector.avatarUploadeded === 'success' ||
         selector.avatarUploadeded === 'failed',
   ]);


   // Define a function to update the window width
   const updateMobileState = () => {
      if (window.innerWidth <= 1120) {
         setIsMobile(true);
      } else {
         setIsMobile(false);
      }
   };

   useEffect(() => {
      window.addEventListener('resize', updateMobileState);
      if (window.innerWidth <= 1120) {
         setIsMobile(true);
      } else {
         setIsMobile(false);
      }
      // Clean up the event listener when the component unmounts
      return () => {
         window.removeEventListener('resize', updateMobileState);
      };
   }, []);

   return (
      <>
         <HeaderWrapper
            display="flex"
            alignItems="center"
            textAlign="right"
            sx={{
               boxShadow: `0px 2px 8px -3px rgb(34 51 84 / 20%), 0px 5px 22px -4px rgb(34 51 84 / 10%)`,
            }}
         >
            <div></div>

            <Button
               onClick={() => setCalculate(true)}
               sx={{
                  display: { xs: "block", sm: "none" },
                  fontWeight: "700",
                  background: "#0040bf",
                  padding: "0.5rem",
                  fontSize: "0.6rem",
                  borderRadius: "8px",
                  color: "#fff",
              
                  
               }}
            >
               Price Calculator
            </Button>

            <Box
               display="flex"
               alignItems="center"
               textAlign="center"
               gap={3}
               sx={{
                  display: { xs: "none", sm: "flex" }, 
               }}
            >
              <Typography>
                <Button
                   onClick={() => setCalculate(true)}
                   sx={{
                      fontWeight: "700",
                      background: "#0040bf",
                      padding: "0.6rem",
                      paddingX: "1rem",
                      fontSize: "0.9rem",
                      borderRadius: "8px",
                      color: "#fff",
                    
                      '&:hover': {
                        opacity: 0.9,
                        backgroundColor: "#0040bf",
                      },
                   }}
                >
                   Price Calculator
                </Button>
              </Typography>
               
               {/* <Tooltip arrow title="Notifications">
                  <NotificationsBadge badgeContent={4}>
                     <NotificationsNoneSharpIcon
                        sx={{
                           color: 'white',
                        }}
                     />
                  </NotificationsBadge>
               </Tooltip> */}
               
               <Box display="flex" alignItems="center" textAlign="center" gap={1}>
                  <Box
                     sx={{
                        '@media(max-width:735px)': {
                           display: 'none',
                        },
                     }}
                  >
                     <Typography fontWeight={400} align="left" fontSize={13} color="#666666">
                        {isMorning}!
                     </Typography>
                     <Typography
                        align="left"
                        fontSize={16}
                        color="#666666"
                        fontWeight={400}
                     >
                        {userLSAuth()?.fullName ? userLSAuth()?.fullName : ''}
                     </Typography>
                  </Box>
                  <ProfileMenu getLogOutState={getLogOutState}>
                     <img
                        style={{
                           width: '50px',
                           height: '50px',
                           borderRadius: '50%',
                        }}
                        src={img}
                        alt="Profile"
                     />
                  </ProfileMenu>
               </Box>
            </Box>
            
            <Dialog 
               maxWidth="md"
               fullWidth
               fullScreen={isMobile} 
               PaperProps={{
                  sx: {
                     backgroundColor: {
                        xs: 'white',                    
                        sm: 'transparent', 
                     }
                  }
               }}  
               onClose={() => setCalculate(false)} 
               open={calculate}
            >
               <CalculatorApp />
            </Dialog>
         </HeaderWrapper>
      </>
   );
};

export default Header;